import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { observer } from 'mobx-react'


export const Button = observer((props) => {

    const size = {
      large: { height: '75px', fontSize: '23px' },
      medium: { height: '50px' },
      small: { height: '25px' }
    }

    const theme = { ...size[props.size], ...props.customStyles }
    return (
      <StyledButton {...props} theme={themes[props.color]}
                    style={{ ...theme, ...props.style }}
      >
        {props.text}
      </StyledButton>
    )
  }
)

Button.propTypes = {
  text: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['large', 'medium', 'small']),
  color: PropTypes.oneOf(['blue', 'white', 'red']),
  onClick: PropTypes.func,
  customStyles: PropTypes.object,
  type: PropTypes.string,
  onSubmit: PropTypes.func
}

Button.defaultProps = {
  size: 'medium',
  color: 'blue'
}

const StyledButton = styled.button`
  padding-left: 20px;
  padding-right: 20px;
  color: white;
  font-size: 16px;
  border-radius: 10px;
  margin: 0 auto;
  cursor: pointer;
  min-width: 125px;
  outline: none;
  border: none;
  background: ${p => p.theme.bg};

  &:hover {
    background: ${p => p.theme.hoverBg};
  }

  &:focus {
    background: deepskyblue;
  }

  &:disabled {
    background: #97b7d0;
  }
  @media (max-width: 1110px) {
    font-size: 14px

  }
`
let themes = {
  blue: {
    bg: '#009FF5',
    color: 'white',
    hoverBg: 'deepskyblue'
  },
  white: {
    bg: 'white',
    color: '#6AC8FC'
  } ,
  red: {
    bg: 'rgba(255, 0, 124, 1)',
    color: 'white',
    hoverBg: 'rgba(255, 0, 124, 1)'
  }
}

export default Button